import React from 'react'
import './HomePage.css'
import { Row, Col, Container } from 'react-bootstrap'
import Information from '../../components/Information/Information'
import HeroComponent from '../../components/HeroComponent/HeroComponent'
import { useTranslation } from 'react-i18next'
import ContactForHomePage from '../Contact/ContactForHomePage'
import IndexingForHome from '../Indexing/IndexingForHome/IndexingForHome'
import ArchiveForHomePage from '../Archive/components/ArchiveForHomePage'
import OldCovers from './components/OldCovers'
import { Helmet } from 'react-helmet'

import CurrentIssue from '../../components/CurrentIssue/CurrentIssue'

const HomePage = () => {
  const { t } = useTranslation()

  return (
    <>
      {/* <DynamicModuleLoader reducers={reducer}> */}
      <Helmet>
        <meta charSet='utf-8' />
        <title>{t('homepage.title')}</title>
        
        {/* Primary Meta Tags */}
        <meta name="description" content="Moambe - Georgian Scientific Journal. A leading academic publication featuring research articles and scientific studies from Georgia. მოამბე - საქართველოს სამეცნიერო ჟურნალი. წამყვანი აკადემიური გამოცემა, რომელიც წარმოადგენს სამეცნიერო კვლევებს და სტატიებს საქართველოდან." />
        <meta name="keywords" content="moambe, georgian journal, scientific journal, academic journal, research papers, georgia science, მოამბე, საქართველოს ჟურნალი, სამეცნიერო ჟურნალი, აკადემიური ჟურნალი, სამეცნიერო სტატიები, საქართველოს მეცნიერება" />
        <meta name="author" content="Moambe Journal / მოამბე ჟურნალი" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://moambe.org.ge/" />
        <meta property="og:title" content={t('homepage.title')} />
        <meta property="og:description" content="Moambe - Georgian Scientific Journal. A leading academic publication featuring research articles and scientific studies from Georgia. მოამბე - საქართველოს სამეცნიერო ჟურნალი. წამყვანი აკადემიური გამოცემა, რომელიც წარმოადგენს სამეცნიერო კვლევებს და სტატიებს საქართველოდან." />
        <meta property="og:image" content="http://moambe.org.ge/og-image.jpg" />
        <meta property="og:site_name" content="Moambe Journal / მოამბე ჟურნალი" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="http://moambe.org.ge/" />
        <meta property="twitter:title" content={t('homepage.title')} />
        <meta property="twitter:description" content="Moambe - Georgian Scientific Journal. A leading academic publication featuring research articles and scientific studies from Georgia. მოამბე - საქართველოს სამეცნიერო ჟურნალი. წამყვანი აკადემიური გამოცემა, რომელიც წარმოადგენს სამეცნიერო კვლევებს და სტატიებს საქართველოდან." />
        <meta property="twitter:image" content="http://moambe.org.ge/og-image.jpg" />

        {/* Additional SEO Meta Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English, Georgian" />
        <meta name="revisit-after" content="7 days" />
        <meta name="generator" content="React" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="http://moambe.org.ge/" />
        
        {/* Language */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:locale:alternate" content="ka_GE" />
        
        {/* Additional Meta Tags for Academic Content */}
        <meta name="citation_journal_title" content="Moambe / მოამბე" />
        <meta name="citation_publisher" content="Moambe Journal / მოამბე ჟურნალი" />
        <meta name="citation_publication_date" content="2024" />
      </Helmet>
      <HeroComponent />
      <div className='homepage-container'>
        <Container>
          <div id='Home-page' className='home-page'>
            <CurrentIssue />
            <Col>
              <Information />
            </Col>
            <Row>
              <ArchiveForHomePage />
            </Row>
            <Row className='old-cover-images'>
              <OldCovers />
            </Row>
            <Row>
              <ContactForHomePage />
            </Row>
          </div>
          <Col>
            <IndexingForHome />
          </Col>
        </Container>
      </div>
      {/* </DynamicModuleLoader> */}
    </>
  )
}

export default HomePage
